<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="560" scrollable persistent>
      <v-card class="rounded-lg">
        <v-card-title> แก้ไข TagSource (Update) </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6">
          <v-layout row wrap justify-center align-center>
            <v-flex xs10 lg10 pt-6>
              <!-- <v-text-field
                v-model="ReferenceVersion"
                dense
                outlined
                prepend-icon="mdi-clipboard-text-outline"
                label="แก้ไข TagSource (Update)"
              ></v-text-field> -->
              <v-combobox
                color="#077893"
                v-model="itemsRequestTag"
                :items="itemsRequestTag"
                required
                persistent-hint
                append-icon=""
                hide-selected
                multiple
                outlined
                dense
                clearable
                small-chips
                deletable-chips
              >
              </v-combobox>
              <!-- {{ itemsRequestTag }} -->
            </v-flex>
            <v-flex xs1 lg1 ml-2>
              <!-- <v-btn @click="Fn_Save('delete')" color="error" x-small fab
                  ><v-icon>mdi-delete-outline</v-icon>
                </v-btn> -->
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn color="#077893" outlined @click="close()">
            {{ $t("consentform.close") }}
          </v-btn>
          <v-btn color="#077893" dark @click="Fn_Save('save')">
            {{ $t("policyForm.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <!-- <v-form ref="form" v-model="valid" lazy-validation>
      </v-form> -->
    </v-dialog>
  </div>
</template>
<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import authorization from "@/functions/authorization.js";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "data"],
  data: function () {
    return {
      valid: true,
      ReferenceVersion: "",
      StatusReference: "",
      itemsRequestTag: [],
      addRequestFixTag: "",
    };
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    async Fn_Save(val) {
      // if (val === "save") {
      //   this.StatusReference = this.ReferenceVersion;
      // } else if (val === "delete") {
      //   this.StatusReference = "DELETE";
      //   this.ReferenceVersion = "";
      //   this.$refs.form.reset();
      // }
      var payload = {
        ConsentId: this.data.ConsentId,
        BusinessId: this.data.BusinessId,
        AccountId: this.$cookies.get("OneAccountId"),
        // Status: this.data.Status,
        TagSource: this.itemsRequestTag.join(", "),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "consent/UpdateTagSource",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              title: response.data.Message,
            });
            this.$emit("close");

            this.$emit("reset");
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
      // if (this.$refs.form.validate()) {
      // }
    },
    Fn_DeleteConsentId() {},
    close() {
      this.FileUpload = [];
      // this.$refs.form.reset();
      this.$emit("close");
    },
  },
  mounted() {
    this.itemsRequestTag = this.data.TagSource;
    var FixArrayTag = this.itemsRequestTag;
    if (FixArrayTag == "") {
    } else {
      this.itemsRequestTag = FixArrayTag.split(",").map((item) => item.trim());

    }
  },
  watch: {
    show(val) {

      if (val === true) {
        this.itemsRequestTag = this.data.TagSource;
        var FixArrayTag = this.itemsRequestTag;
        if (FixArrayTag == "") {
        } else {
          this.itemsRequestTag = FixArrayTag.split(",").map((item) =>
            item.trim()
          );

        }
      }
    },
  },
};
</script>
